import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Flex round trip flag.
 *
 * @remarks
 * System-managed flag marking a round trip move as a "flex" round trip.
 * Affects scenario type detection for billing and reporting.
 */
export const schema = z.boolean().optional();

export type IsFlex = z.infer<typeof schema>;

export const definition = define({
  key: 'isFlex',
  schema,
  label: 'Is Flex',
  description: 'Marks a round trip as flex type for scenario detection. Set by system, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
